// Copyright (c) 2016 Deere & Company

import './user-popover.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import LinkObject from '@deere/cps-it.warranty-model-factory/lib/link';
import Popover from '../shared/components/popover/popover';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {getLinks} from '../shared/services/get-links';
import {hasAccess} from '../shared/services/security';
import {logout} from '../shared/services/okta';
const UserPopover = (props, context) => {

    const popoverTarget = (
        <span>
            <span className='user'>
                {`${props.firstName} ${props.lastName}`}
            </span>
            <span className='user-popover-caret'/>
        </span>
    );

    const popoverContent = (
        <div className='user-popover-content'>
            <ul>
                {props.isSapUp ?
                    <li>
                        <Link
                            to={'/settings'}
                        >
                            <FormattedMessage id='SETTINGS'/>
                        </Link>
                    </li> : <li className='sapdownfont'> <FormattedMessage id='SETTINGS'/> </li>
                }
                <li>
                    <button
                        className='button-text logout-button'
                        onClick={logout}
                    >
                        <FormattedMessage id='SIGN_OUT'/>
                    </button>
                </li>
            </ul>
            {hasAccess(context.security, 'WELCOME_PAGE', 'EXTERNAL_LINKS') &&
                <ul className='external-links'>
                    {getLinks(props.links, 'WELCOME_PAGE').map((link, index) =>
                        <li key={index}>
                            <a
                                href={link.url}
                                rel='noopener noreferrer'
                                target='_blank'
                            >
                                {link.label}
                            </a>
                        </li>
                    )}
                </ul>
            }
        </div>
    );

    return (
        <Popover
            content={popoverContent}
            target={popoverTarget}
        />
    );

};

UserPopover.displayName = 'UserPopover';
UserPopover.propTypes = {
    firstName: PropTypes.string.isRequired,
    isSapUp: PropTypes.bool.isRequired,
    lastName: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.instanceOf(LinkObject)).isRequired
};
UserPopover.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default UserPopover;



// WEBPACK FOOTER //
// ./src/app/user-popover.js